import { combineReducers } from "redux";

import { appReducer } from "./app/appReducer";
import { chromiaReducer } from "./chromia/chromiaReducer";
import { proReducer } from "./pro/proReducer";
import { basicReducer } from './basic/basicReducer';
import { modalsReducer } from "./modals/modalsReducer";
import { UIReducer } from "./UI/UIReducer";

export const rootReducer = combineReducers({
	app: appReducer,
	chromia: chromiaReducer,
	pro: proReducer,
	basic: basicReducer,
	modals: modalsReducer,
	UI: UIReducer
});